import React from "react";
import {
  FlexibleContainer,
  RowContainer,
} from "../containers/styledComponents";
import { lightGreys } from "../../styles";
import { CompassParagraph } from "../common/styledComponents";
import { Icon, IconContainer } from "./styledComponents";
import { KPI } from "./KPI";
import { DataEntry } from "../../models/stewardshipModels";

interface KPIBoxProps {
  icon: string | React.ReactNode;
  title: string;
  kpis: DataEntry<number | string>[];
}

export const KPIBox: React.FC<KPIBoxProps> = ({ icon, title, kpis }) => {
  return (
    <FlexibleContainer
      fd="column"
      ai="flex-start"
      style={{
        border: `2px solid ${lightGreys.borderLightGrey}`,
        borderRadius: "6px",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <FlexibleContainer
        bg={lightGreys.KPIBackground}
        br="4px"
        p="5px"
        mt="10px"
        ml="10px"
      >
        {typeof icon === "string" ? (
          <IconContainer p={1} m={1} size={25}>
            <Icon src={icon} />
          </IconContainer>
        ) : (
          icon
        )}
        <CompassParagraph fontSize={14} ml={8}>
          {title}
        </CompassParagraph>
      </FlexibleContainer>
      <RowContainer jc="flex-start" mt={20} wrap="wrap">
        {kpis.map((kpi, index) => (
          <KPI
            key={index}
            value={kpi.value}
            title={kpi.label}
            isPercentage={kpi.isPercentage}
          />
        ))}
      </RowContainer>
    </FlexibleContainer>
  );
};
